// Mock data for CitiBiz Connections
export const companyInfo = {
  name: "CitiBiz Connections",
  tagline: "Your Trusted Partner in Cross-Border Logistics",
  description: "A dynamic logistics and trade support company based in Ghana, committed to delivering reliable and efficient shipping solutions.",
  phone: "+233 27 746 73350",
  email: "citibiz@bizinsolutions.com",
  website: "www.citibizconnections.com",
  address: "Tema Community 3, Site B, Ghana",
  social: {
    facebook: "https://facebook.com/citibizconnections",
    instagram: "https://instagram.com/citibizconnections",
    tiktok: "https://tiktok.com/@citibizconnections"
  },
  logo: "https://customer-assets.emergentagent.com/job_86e8c6df-3644-43e8-83a4-e070d0cf12b2/artifacts/pyhmsu6h_CBC%20White.png"
};

export const services = [
  {
    id: 1,
    title: "Freight Forwarding",
    description: "Air, sea, and land cargo transport solutions tailored to your business needs.",
    icon: "Plane",
    features: ["Air Freight", "Sea Freight", "Land Transport", "Multi-modal Solutions"]
  },
  {
    id: 2,
    title: "Logistics Support",
    description: "Comprehensive coordination of domestic and international shipments.",
    icon: "Truck",
    features: ["Warehousing", "Distribution", "Inventory Management", "Supply Chain"]
  },
  {
    id: 3,
    title: "Export Services",
    description: "Full support for businesses exporting from Ghana to global markets.",
    icon: "Globe",
    features: ["Export Documentation", "Market Access", "Compliance Support", "Trade Advisory"]
  },
  {
    id: 4,
    title: "Customs Clearance",
    description: "Efficient handling of import/export documentation and processes.",
    icon: "FileCheck",
    features: ["Documentation", "Duty Assessment", "Regulatory Compliance", "Fast Processing"]
  },
  {
    id: 5,
    title: "Trade Facilitation",
    description: "Assistance with documentation, compliance, and logistics planning.",
    icon: "Handshake",
    features: ["Trade Finance", "Risk Assessment", "Partnership Support", "Advisory Services"]
  }
];

export const coreValues = [
  {
    id: 1,
    title: "Integrity",
    description: "We uphold the highest ethical standards, always doing what is right.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Speed",
    description: "We measure success by our ability to deliver on time, every time.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Reliability",
    description: "We are dedicated to consistently providing excellent and dependable service.",
    icon: "CheckCircle"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Ghana Logistics Experts",
    description: "Deep knowledge of local trade regulations and port operations."
  },
  {
    id: 2,
    title: "Flexible Partnership",
    description: "Ready to support your shipments as needs arise."
  },
  {
    id: 3,
    title: "Proactive Support",
    description: "We're always available to assist with shipments to/from Ghana."
  },
  {
    id: 4,
    title: "Reliable Communication",
    description: "Clear updates, timely support, and a client-first approach."
  },
  {
    id: 5,
    title: "Speed with Accuracy",
    description: "Maximum efficiency with stunning turnaround times."
  }
];

export const turnaroundTimes = [
  { service: "Sea Freight Documentation", time: "24-48 hours" },
  { service: "Air Freight Processing", time: "12-24 hours" },
  { service: "Customs Clearance", time: "48-72 hours" },
  { service: "Export Documentation", time: "24 hours" },
  { service: "Quote Response", time: "< 4 hours" }
];

export const ceoInfo = {
  name: "Korku Sedemor Adjorlolo",
  title: "Chief Executive Officer",
  bio: `Korku Sedemor Adjorlolo is a dynamic sales and logistics professional with over a decade of experience in shipping, logistics, and corporate operations across Ghana and West Africa. With a background in International Oil and Gas Management (MSc) and Psychology (BSc), he brings a strategic and people-focused approach to business development.

Korku has held key roles at leading logistics firms such as McDan Shipping and Aramex Ghana, where he led high-impact sales teams, managed international partnerships, and executed large-scale projects including telecom supply for Ghana's digitization initiative.

He is NEBOSH and IATA certified, with proven expertise in operational efficiency, client relations, and team leadership.`,
  message: `At CitiBiz Connections, we believe that logistics is more than just moving goods—it's about creating seamless, trustworthy pathways that drive growth and opportunity for businesses across borders.\n\nFrom our home base in Ghana to destinations across the continent and beyond, we are proud to support our clients with solutions that are not only compliant and secure but also tailored to their specific trade needs.\n\nThank you for choosing CitiBiz Connections. We look forward to moving your business forward—smoothly, safely, and successfully.`,
  image: "https://images.unsplash.com/photo-1758519291531-e96279895745?w=400&h=400&fit=crop"
};

export const stats = [
  { label: "Years Experience", value: "10+" },
  { label: "Successful Shipments", value: "5000+" },
  { label: "Partner Countries", value: "25+" },
  { label: "Happy Clients", value: "500+" }
];

export const trackingStatuses = [
  "Order Placed",
  "Pickup Scheduled",
  "In Transit to Port",
  "Customs Clearance",
  "In Transit - Sea/Air",
  "Arrived at Destination Port",
  "Final Delivery",
  "Delivered"
];

export const mockShipments = [
  {
    trackingId: "CBC-2025-001234",
    origin: "Tema, Ghana",
    destination: "Rotterdam, Netherlands",
    status: "In Transit - Sea",
    currentStep: 4,
    estimatedDelivery: "August 25, 2025",
    shipmentType: "Sea Freight - FCL",
    weight: "2,500 kg",
    history: [
      { date: "Aug 5, 2025", status: "Order Placed", location: "Tema, Ghana" },
      { date: "Aug 6, 2025", status: "Pickup Completed", location: "Accra, Ghana" },
      { date: "Aug 7, 2025", status: "At Port - Loading", location: "Tema Port" },
      { date: "Aug 8, 2025", status: "Customs Cleared", location: "Tema Port" },
      { date: "Aug 10, 2025", status: "Departed Port", location: "Tema Port" }
    ]
  },
  {
    trackingId: "CBC-2025-001567",
    origin: "Lagos, Nigeria",
    destination: "Tema, Ghana",
    status: "Customs Clearance",
    currentStep: 3,
    estimatedDelivery: "August 18, 2025",
    shipmentType: "Air Freight",
    weight: "150 kg",
    history: [
      { date: "Aug 12, 2025", status: "Order Placed", location: "Lagos, Nigeria" },
      { date: "Aug 13, 2025", status: "Pickup Completed", location: "Lagos Airport" },
      { date: "Aug 14, 2025", status: "In Transit", location: "Airborne" },
      { date: "Aug 14, 2025", status: "Arrived", location: "Kotoka Int'l Airport" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Akosua Mensah",
    company: "GoldStar Exports Ltd.",
    text: "CitiBiz Connections has transformed our export operations. Their attention to detail and understanding of local regulations is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Emmanuel Osei",
    company: "Osei Trading Co.",
    text: "Reliable, fast, and always professional. Our shipments arrive on time, every time. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Fatima Abubakar",
    company: "Northern Commodities",
    text: "The customs clearance service is exceptional. They handle all the paperwork seamlessly.",
    rating: 5
  }
];

export const partners = [
  { name: "Ghana Shippers Authority", logo: "GSA" },
  { name: "Ghana Ports & Harbours", logo: "GPHA" },
  { name: "Maersk Line", logo: "MAERSK" },
  { name: "DHL Ghana", logo: "DHL" },
  { name: "ICUMS", logo: "ICUMS" }
];
